<script setup lang="ts">
  import { computed } from "vue";
  import type { MarketoUserInputMeta } from "../types/definitions/inputs/marketo-input-meta.js";
  import type { InputState } from "../composables/use-input-state.js";
  import { type Nil } from "@mcwd/typescript-type-guards";
  import { useVModel, refDefault } from "@vueuse/core";
  import { getFormDropdownOptionKeys } from "../types/definitions/inputs/select-box-fields.js";
  import eclipseInput from "./eclipse-input.vue";

  export interface MainSolutionInterestProps {
    formInputMeta: MarketoUserInputMeta,
    inputState: InputState
    modelValue: string | string[] | number | boolean | Nil;
    disableQualer?: boolean;
  }

  const props = defineProps<MainSolutionInterestProps>();

  const emit = defineEmits<(e: 'update:modelValue', modelValue: MainSolutionInterestProps["modelValue"]) => void>();

  const SolutionOptions = getFormDropdownOptionKeys(["Latest_Solution_Interest__c"]).Latest_Solution_Interest__c;
  
  const mainSolutionInterestOpts = computed( () => {
    if(props?.disableQualer === true) {
      return SolutionOptions.filter( opt => {
        return opt !== "Asset Management";
      });
    } else {
      return SolutionOptions;
    }
  });
  
  const proxyModelValue = refDefault(useVModel(props, 'modelValue', emit), null);
</script>

<template>
  <eclipseInput
    v-model="proxyModelValue"
    :input-state="props.inputState"
    :form-input-meta="props.formInputMeta"
    :dropdown-option-keys="mainSolutionInterestOpts"
    dropdown-translations-namespace="main-solutions"
  />
</template> 
